import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Camera } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const KUTU = "bayi-kamera-alani";

const Okuyucu = ({ onOku }) => {
  const [hata, setHata] = useState("");
  const cb = useRef(onOku);
  cb.current = onOku;
  useEffect(() => {
    const k = new Html5Qrcode(KUTU);
    let bitti = false;
    const dur = () => { if (k.isScanning) k.stop().catch(() => {}); };
    k.start({ facingMode: "environment" }, { fps: 10, qrbox: (w, h) => ({ width: Math.max(50, Math.min(300, w - 20)), height: Math.max(50, Math.min(140, h - 20)) }) },
      (metin) => { if (bitti) return; bitti = true; dur(); cb.current(metin.trim()); }, () => {})
      .then(() => { if (bitti) dur(); })
      .catch(() => setHata("Kameraya erişilemedi. Tarayıcıdan kamera izni verin ve sayfayı güvenli (https) bağlantıyla açın."));
    return () => { bitti = true; dur(); };
  }, []);
  return (
    <div className="space-y-3">
      <div id={KUTU} data-testid="bayi-kamera-alani" className="w-full min-h-[220px] rounded-xl overflow-hidden bg-black/40" />
      {hata ? <p className="text-sm text-red-300" data-testid="bayi-kamera-hata">{hata}</p>
        : <p className="text-xs text-muted-foreground">Barkodu çerçevenin içine tutun; okununca ürün açılır.</p>}
    </div>
  );
};

export const BarkodKamera = ({ onOku, testid = "bayi-kamera", etiket = "Kamerayla okut" }) => {
  const [acik, setAcik] = useState(false);
  const oku = (m) => { setAcik(false); onOku(m); };
  return (
    <>
      <button type="button" data-testid={testid} onClick={() => setAcik(true)} title="Kamerayla barkod okut"
        className="inline-flex items-center justify-center gap-2 h-11 px-4 rounded-full bg-white/5 border border-white/10 text-sm hover:bg-white/10 transition-colors active:scale-95">
        <Camera className="w-4 h-4" /><span className="sm:hidden lg:inline">{etiket}</span></button>
      <Dialog open={acik} onOpenChange={setAcik}>
        <DialogContent className="glass max-w-md" data-testid="bayi-kamera-dialog">
          <DialogHeader><DialogTitle>Barkod okut</DialogTitle></DialogHeader>
          {acik && <Okuyucu onOku={oku} />}
        </DialogContent>
      </Dialog>
    </>
  );
};
